import React, {lazy, Suspense} from 'react';
import Render from './render';

const ImageLayout = lazy(() => import("../../components/imageLayout/imageLayout"));
const Video = lazy(() => import('../../components/video/video'));

/**
 * 
 * 
 * @category Renders
 * @summary Renders the mediaTypes
 * @return {array} navigation components
 * 
 */
const RenderMedia = ({data, ...other}) => {

  const map = {
    'DatoCmsComponentImage': ImageLayout,
    'DatoCmsComponentVideo' : Video
  }

  return (
    <Suspense fallback="">
      <Render data={data} map={map} {...other} />
    </Suspense>
  ) 
};

export default RenderMedia;


